export default __webpack_public_path__ + "static/media/picture2.590447e8.png";